enum ProjectBoardType {
    Default = 1,
    Tasks,
    Goals,
}

export default ProjectBoardType;
